<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="850px"
    @close="close"
  >
    <h4>以下单据中的货品已上传过随单证照，是否继续新增证照</h4>
    <p class="color-danger">提示：您可选择想要更新的单据或货品，提交时会更新您选择的单据货品证照</p>
    <SubTable
      :list="list"
      :show-name="true"
      height="350px"
      @selection-change="selectionChange"
    />
    <div slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>

import SubTable from './SubTable.vue'
// 使用方法：
// 1.引入组件
// import DialogExampleVue from "../components/Dialog.example.vue";
// 2.注册组件
// components: { DialogExampleVue }
// 4.页面使用组件
// <DialogExampleVue ref="dialog" />
// 5.打开组件
// this.refs.dialog.show({});

export default {
  components: {
    SubTable
  },
  data() {
    return {
      list: [],
      selected: [],
      dialogVisible: false,
    };
  },
  methods: {
    set(key, value) {
      this[key] = value
      return this
    },
    /**
     * 显示弹窗
     * params 传入的参数
     */
    show(params) {
      console.log('params>>>', params)
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    selectionChange(rows) {
      this.selected = rows || []
    },
    submitForm() {
      this.$emit('confirm', {
        all: this.list,
        selected: this.selected
      })
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
.color-danger{
  color: #F56C6C;
}
</style>
